import { withIcon } from '@/camo/icons/with-icon'
import ReactComponent from './svg/close.svg'

const Close = withIcon(ReactComponent, { title: 'Close' })

export { Close }
